export default {
  play: 'Play Now',
  fullscreen: 'Fullscreen Mode',
  addToFavorites: 'Add to Favorites',
  removeFromFavorites: 'Remove from Favorites',
  similarGames: 'Similar Games',
  howToPlay: 'How to Play',
  gameDescription: 'Game Description',
  controlsAndInstructions: 'Controls & Instructions',
  share: 'Share',
  gameUnavailable: 'Game Unavailable',
  tryAgainLater: 'This game is currently unavailable. Please try again later.',
  openInNewTab: 'Open in New Tab',
  gameTitle: 'Game Title',
  genres: 'Game Genres',
  tags: 'Tags',
  noGenre: 'No genre',
  noTags: 'No tags',
  new: 'New Game',
  playAmazingGame: 'Play this amazing game now!',
  noSimilarGames: 'No Similar Games',
  gameNotFound: 'Game Not Found',
  gameNotExistOrRemoved: 'The game you are looking for does not exist or has been removed.',
  backToHome: 'Back to Home',
  seoTitle: '{title} - Play Online - GoGameVault',
  seoTitleNotFound: 'Game Not Found - GoGameVault',
  seoKeywords: 'play {title}, free online games, {tags} games',
  gameFeatures: 'Game Features',
  controlDetails: 'Control Details'
}; 